import { Alert, Link, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { memo } from 'react';
import { settingsQueryOptions } from '@/api/services/settings';

export const IncidentBanner = memo(function IncidentBanner({
  variant = 'rounded',
}: {
  variant?: 'rounded' | 'rectangular';
}) {
  const { data: incident } = useQuery({ ...settingsQueryOptions, select: ({ incident }) => incident });

  if (!incident) {
    return null;
  }

  return (
    <Alert variant="standard" severity="info" sx={variant === 'rectangular' ? { borderRadius: 0 } : undefined}>
      <Typography
        variant="body2"
        sx={{
          color: 'text.primary',
        }}
      >
        We are experiencing service disruptions. Please visit our{' '}
        <Link href="https://status.qdrant.io/" target="_blank" variant="body2" underline="always">
          status page
        </Link>{' '}
        for updates.
      </Typography>
    </Alert>
  );
});
